import { call, put } from "redux-saga/effects";
import { vehicleConstants } from "../actions/constants/vehicleConstants";
import { commonConstants } from "../actions/constants/commonConstants";
import { vehicleService } from "../services/vehicleService";

function* listVehicles(action: any): any {
  try {
    const response = yield call(vehicleService.getVehiclesParams, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.getVehicleParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: vehicleConstants.getVehicleParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.getVehicleParamsFailure, payload: error });
  }
}

function* createVehicle(action: any): any {
  try {
    const response = yield call(vehicleService.createVehicle, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.vehicleCreateSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: vehicleConstants.vehicleCreateFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.vehicleCreateFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error });
  }
}

function* toggleVehicle(action: any): any {
  try {
    const response = yield call(vehicleService.toggleVehicle, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.vehicleToggleSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
      // re-fetch list
      yield put({ type: vehicleConstants.getVehicleParamsRequest });
    } else {
      yield put({ type: vehicleConstants.vehicleToggleFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.vehicleToggleFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error });
  }
}

function* deleteVehicle(action: any): any {
  try {
    const response = yield call(vehicleService.deleteVehicle, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.vehicleDeleteSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: vehicleConstants.vehicleDeleteFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.vehicleDeleteFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error });
  }
}

function* viewVehicle(action: any): any {
  try {
    const response = yield call(vehicleService.viewVehicle, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.vehicleViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: vehicleConstants.vehicleViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.vehicleViewFailure, payload: error });
  }
}

function* uploadVehicle(action: any): any {
  try {
    const response = yield call(vehicleService.uploadImage, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.vehicleUploadSuccess, payload: response.resultObject ?? response });
        yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: vehicleConstants.vehicleUploadFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.vehicleUploadFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error });
  }
}

function* saveTripSheet(action: any): any {
  try {
    const response = yield call(vehicleService.saveTripSheet, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.tripSheetSaveSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: vehicleConstants.tripSheetSaveFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.tripSheetSaveFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error });
  }
}

function* listTripSheets(action: any): any {
  try {
    const response = yield call(vehicleService.listTripSheets, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.tripSheetListSuccess, payload: response.resultObject });
    } else {
      yield put({ type: vehicleConstants.tripSheetListFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.tripSheetListFailure, payload: error });
  }
}

function* viewTripSheet(action: any): any {
  try {
    const response = yield call(vehicleService.viewTripSheet, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.tripSheetViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: vehicleConstants.tripSheetViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.tripSheetViewFailure, payload: error });
  }
}

function* deleteTripSheet(action: any): any {
  try {
    const response = yield call(vehicleService.deleteTripSheet, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.tripSheetDeleteSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: vehicleConstants.tripSheetDeleteFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.tripSheetDeleteFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || error });
  }
}

function* listTripSheetsByVehicle(action: any): any {
  try {
    const response = yield call(vehicleService.listTripSheetsByVehicle, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.tripSheetByVehicleSuccess, payload: response.resultObject });
    } else {
      yield put({ type: vehicleConstants.tripSheetByVehicleFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.tripSheetByVehicleFailure, payload: error });
  }
}

function* listTripSheetsByBatch(action: any): any {
  try {
    const response = yield call(vehicleService.listTripSheetsByBatch, action.payload);
    if (response.success) {
      yield put({ type: vehicleConstants.tripSheetByBatchSuccess, payload: response.resultObject });
    } else {
      yield put({ type: vehicleConstants.tripSheetByBatchFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: vehicleConstants.tripSheetByBatchFailure, payload: error });
  }
}

export const vehicleSaga = {
  listVehicles,
  createVehicle,
  toggleVehicle,
  deleteVehicle,
  viewVehicle,
  uploadVehicle,
  saveTripSheet,
  listTripSheets,
  viewTripSheet,
  deleteTripSheet,
  listTripSheetsByVehicle,
  listTripSheetsByBatch,
};
